import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, Button, Icon, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { DataGrid } from '../../common';
import { getMenuTranslationsTable } from '../../../selectors';
import { fetchRestaurantMenuTranslations, updateRestaurantMenuTranslations, initRestaurantMenuTranslations } from '../../../actions';

const LANGUAGES = ['en', 'ar', 'he'];

class MenuTranslations extends Component {
    state = { updates: {}, selectedLanguages: [] }

    componentDidMount() {
        if (this.props.menuId) {
            this.props.fetchRestaurantMenuTranslations(this.props.menuId);
        }
    }

    handleUpdate = () => {
        this.props.updateRestaurantMenuTranslations(this.props.menuId, this.state.updates, () => {
            this.setState({ updates: {} });
        });
    }

    handleInitTranslation = (languages = this.props.menuLanguages) => {
        this.props.initRestaurantMenuTranslations(this.props.menuId, languages);
    }

    renderCreationButton() {
        const isDirty = Object.keys(this.state.updates).length;

        return (
            <div>
                {!isDirty ? null :
                    <Button
                        icon
                        labelPosition='left'
                        floated="right"
                        primary
                        onClick={this.handleUpdate}
                    >
                        <Icon name='save' /> {i18next.t('save')}
                    </Button>
                }
                {!isDirty ? null :
                    <Button
                        icon
                        labelPosition='left'
                        floated="right"
                        onClick={() => this.setState({ updates: {} })}
                    >
                        <Icon name='undo' /> {i18next.t('cancel')}
                    </Button>
                }

                <Button
                    icon
                    floated="right"
                    basic
                    onClick={() => this.handleInitTranslation()}
                    style={{ marginLeft: 10, marginRight: 10, width: 250 }}
                >
                    <Icon name='refresh' /> {i18next.t('refreshMenuTranslations')}
                </Button>

                <Button.Group
                    buttons={LANGUAGES.map(key => {
                        const active = this.props.menuLanguages.includes(key);
                        return {
                            key,
                            content: key.toUpperCase(),
                            active,
                            onClick: () => active ? null : this.handleInitTranslation([key])
                        };
                    })}
                />
            </div>
        );
    }

    render() {
        if (!this.props.menuId) return null;

        if (!this.props.menuLanguages.length) {
            return (
                <div style={{ padding: 10 }}>
                    <Dropdown
                        multiple
                        selection
                        placeholder={i18next.t('choose')}
                        options={LANGUAGES.map((lang) => ({ value: lang, text: i18next.t('languages.' + lang) }))}
                        value={this.state.selectedLanguages || []}
                        onChange={(e, { value }) => this.setState({ selectedLanguages: value.length ? value : [] })}
                    />
                    <div>
                        <Button
                            primary
                            onClick={() => this.handleInitTranslation(this.state.selectedLanguages)}
                            style={{ marginTop: 20, width: 200 }}
                            disabled={!this.state.selectedLanguages.length}
                        >
                            {i18next.t('initMenuTranslations')}
                        </Button>
                    </div>
                </div>
            );
        }

        const columns = [{
            Header: i18next.t('main'),
            accessor: 'main',
            filterable: true
        }].concat(this.props.menuLanguages.map(lang => ({
            Header: i18next.t('languages.' + lang),
            accessor: lang,
            filterable: true,
            Cell: (cellInfo) => {
                const row = cellInfo.original;

                let style = {};
                // if (lang === 'en') {
                //     style = { direction: 'ltr', textAlign: 'left' };
                // }

                const value = (row.main in (this.state.updates[lang] || {})) ? this.state.updates[lang][row.main] : row[lang];

                return (
                    <Input
                        style={style}
                        fluid
                        value={value}
                        onChange={({ target }) => {
                            if (row[lang] !== target.value) {
                                const { updates } = this.state;
                                if (!updates[lang]) {
                                    updates[lang] = {};
                                }
                                updates[lang][row.main] = target.value;
                                this.setState({ updates });
                            }
                        }}
                        onBlur={() => {
                            if (!value) {
                                const { updates } = this.state;
                                if (updates[lang]) {
                                    updates[lang][row.main] = row[lang];
                                    this.setState({ updates });
                                }
                            }
                        }}
                    />
                );
            }
        })));

        return (
            <div style={{ flex: 1, overflow: 'auto', padding: 10, paddingBottom: 120 }}>
                <DataGrid
                    data={this.props.menuTranslations}
                    columns={columns}
                    extraActions={this.renderCreationButton()}
                />
            </div>
        );
    }
}

MenuTranslations.propTypes = {
    fetchRestaurantMenuTranslations: PropTypes.func,
    updateRestaurantMenuTranslations: PropTypes.func,
    initRestaurantMenuTranslations: PropTypes.func,
    menuTranslations: PropTypes.array,
    menuLanguages: PropTypes.array,
    menuId: PropTypes.string,

};

function mapStateToProps(state) {
    const menuTranslations = getMenuTranslationsTable(state);
    const menuLanguages = Object.keys(state.businessApp.menu.translationDictionary).filter(lang => Object.keys(state.businessApp.menu.translationDictionary[lang]).length);

    return { menuTranslations, menuLanguages };
}
export default connect(mapStateToProps, { fetchRestaurantMenuTranslations, updateRestaurantMenuTranslations, initRestaurantMenuTranslations })(MenuTranslations);
